import { render, staticRenderFns } from "./DreesTeam.vue?vue&type=template&id=edf9a58c&scoped=true&"
import script from "./DreesTeam.vue?vue&type=script&lang=ts&"
export * from "./DreesTeam.vue?vue&type=script&lang=ts&"
import style0 from "./DreesTeam.vue?vue&type=style&index=0&id=edf9a58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf9a58c",
  null
  
)

export default component.exports